import { render, staticRenderFns } from "./TrainingTagsForm.vue?vue&type=template&id=130a1073&scoped=true&"
import script from "./TrainingTagsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingTagsForm.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTagsForm.vue?vue&type=style&index=0&id=130a1073&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a1073",
  null
  
)

export default component.exports